export default "__VITE_ASSET__d69cfafb__"